// conduit-calculadora.js — Sily.mx
// Se inicializa cuando el DOM esté listo, compatible con Shopify

(function () {
  'use strict';

  var CABLES = {
    '5e': { nombre: 'Cat 5E — Belden 1583A', part: 'Belden 1583A', diam: 4.826,  awg: 24, freq: '200 MHz', tipo: 'UTP 4 pares',   jacket: 'PVC CMR', url: 'https://www.sily.mx/collections/cables-utp/products/belden-1583a' },
    '6':  { nombre: 'Cat 6+ — Belden 2412',  part: 'Belden 2412',  diam: 5.6896, awg: 23, freq: '350 MHz', tipo: 'U/UTP 4 pares', jacket: 'PVC CMR', url: 'https://www.sily.mx/collections/cables-utp/products/belden-2412' },
    '6A': { nombre: 'Cat 6A — Belden 10GXS12', part: 'Belden 10GXS12', diam: 6.9342, awg: 23, freq: '625 MHz', tipo: 'UTP 4 pares', jacket: 'PVC CMR', url: 'https://www.sily.mx/collections/cables-utp/products/belden-10gxs12' },
    'custom': { nombre: 'Cable personalizado', part: '—', diam: 5.5, awg: '—', freq: '—', tipo: '—', jacket: '—', url: null }
  };

  var CID = {
    emt: { 16:15.80, 21:20.93, 27:26.64, 35:35.05, 41:40.89, 53:52.50, 63:62.71, 78:69.85, 91:85.22, 103:97.38 },
    imc: { 16:14.58, 21:19.43, 27:25.15, 35:32.46, 41:38.10, 53:50.80, 63:60.96, 78:72.64, 91:84.07, 103:97.38 },
    rmc: { 16:13.36, 21:18.29, 27:24.13, 35:31.75, 41:38.10, 53:50.80, 63:62.71, 78:72.39, 91:85.34, 103:97.38 },
    pvc: { 16:15.29, 21:20.40, 27:26.14, 35:33.27, 41:39.27, 53:51.56, 63:63.50, 78:73.66, 91:85.85, 103:97.89 }
  };

  var SIZES  = [16, 21, 27, 35, 41, 53, 63, 78, 91, 103];
  var SLBL   = { 16:'½"', 21:'¾"', 27:'1"', 35:'1¼"', 41:'1½"', 53:'2"', 63:'2½"', 78:'3"', 91:'3½"', 103:'4"' };
  var ARROW  = '<svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 15L15 5M15 5H8M15 5v7"/></svg>';

  function maxC(d, t, s)     { var id = CID[t][s]; return Math.floor((Math.PI * Math.pow(id/2,2) * 0.40) / (Math.PI * Math.pow(d/2,2))); }
  function pctC(d, t, s, n)  { var id = CID[t][s]; return (Math.PI * Math.pow(d/2,2) * n) / (Math.PI * Math.pow(id/2,2)) * 100; }
  function chips(arr)         { return '<div class="conduit-chips">' + arr.map(function(i){ return '<span class="conduit-chip">' + i + '</span>'; }).join('') + '</div>'; }
  function esc(s)             { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function init() {
    var form = document.getElementById('conduit-form');
    if (!form) return; // no está en esta página

    var selCat      = document.getElementById('cc-cat');
    var selTipo     = document.getElementById('cc-tipo');
    var selSize     = document.getElementById('cc-size');
    var inputN      = document.getElementById('cc-ncables');
    var customWrap  = document.getElementById('cc-custom-wrap');
    var inputCustom = document.getElementById('cc-custom-diam');
    var resultBox   = document.getElementById('cc-result');

    // Mostrar/ocultar campo diámetro personalizado
    selCat.addEventListener('change', function () {
      customWrap.style.display = this.value === 'custom' ? 'block' : 'none';
    });

    // Submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var catKey = selCat.value;
      var tipo   = selTipo.value;
      var size   = parseInt(selSize.value, 10);
      var n      = Math.max(1, parseInt(inputN.value, 10) || 1);
      var diam   = catKey === 'custom'
        ? (parseFloat(String(inputCustom.value).replace(',', '.')) || 5.5)
        : CABLES[catKey].diam;

      var c      = CABLES[catKey];
      var max    = maxC(diam, tipo, size);
      var p      = pctC(diam, tipo, size, n);
      var pmax   = pctC(diam, tipo, size, max);
      var barCol = p <= 30 ? '#16a34a' : p <= 40 ? '#d97706' : '#dc2626';

      var badgeOk  = n <= max;
      var badgeTxt = badgeOk
        ? '✓ ' + n + ' cable' + (n !== 1 ? 's' : '') + ' → ' + p.toFixed(1) + '% — dentro del límite'
        : '✗ ' + n + ' cables exceden el máximo (' + max + ')';

      // Specs
      var specsHtml = '';
      if (catKey !== 'custom') {
        specsHtml = '<div class="conduit-specs">'
          + '<div class="conduit-specs-title">Especificaciones del cable</div>'
          + chips([c.part, 'AWG ' + c.awg, c.freq, c.tipo, c.jacket, '⌀ ' + diam.toFixed(3) + ' mm'])
          + '</div>';
      }

      // Grid todos los tamaños
      var gridHtml = SIZES.map(function (s) {
        var mn = maxC(diam, tipo, s);
        return '<div class="conduit-cell' + (s === size ? ' active' : '') + '">'
          + '<div class="conduit-cell-size">' + esc(SLBL[s]) + ' (' + s + ' mm)</div>'
          + '<div class="conduit-cell-num ' + (mn > 0 ? 'ok' : 'zero') + '">' + mn + '</div>'
          + '<div class="conduit-cell-lbl">cable' + (mn !== 1 ? 's' : '') + '</div>'
          + '</div>';
      }).join('');

      // Tabla comparativa
      var catRows = [
        { k: '5e', col: '#16a34a' },
        { k: '6',  col: '#2563eb' },
        { k: '6A', col: '#7c3aed' }
      ].map(function (x) {
        var cb = CABLES[x.k];
        var mn = maxC(cb.diam, tipo, size);
        return '<tr' + (x.k === catKey ? ' class="active-row"' : '') + '>'
          + '<td><span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:' + x.col + ';margin-right:5px"></span>' + esc(cb.nombre) + '</td>'
          + '<td style="color:#6b7280">' + esc(cb.part) + '</td>'
          + '<td>' + cb.diam.toFixed(3) + ' mm</td>'
          + '<td>' + cb.awg + '</td>'
          + '<td><span class="conduit-hl">' + mn + ' cables</span></td>'
          + '</tr>';
      }).join('');

      // Productos
      var prodLinks = '';
      if (catKey !== 'custom' && c.url) {
        prodLinks += '<a class="conduit-prod-link" href="' + c.url + '" target="_blank" rel="noopener">' + ARROW + ' ' + esc(c.part) + '</a>';
      }
      prodLinks += '<a class="conduit-prod-link" href="https://www.sily.mx/collections/cables-utp" target="_blank" rel="noopener">' + ARROW + ' Ver todos los cables UTP Belden</a>';
      prodLinks += '<a class="conduit-prod-link" href="https://www.sily.mx/collections/ductos-y-canaletas" target="_blank" rel="noopener">' + ARROW + ' Conduit y canaletas</a>';

      var nombreCable = catKey !== 'custom' ? esc(c.nombre) : '⌀ ' + diam.toFixed(1) + ' mm';
      var refCable    = catKey !== 'custom' ? esc(c.part)   : '⌀ ' + diam.toFixed(1) + ' mm';

      resultBox.innerHTML =
        '<div class="conduit-hero">'
          + '<div class="conduit-hero-num">' + max + '</div>'
          + '<div class="conduit-hero-desc">'
            + '<strong>cables máximo</strong><br>'
            + 'conduit ' + esc(SLBL[size]) + ' ' + tipo.toUpperCase() + ' · ' + nombreCable + ' (⌀ ' + diam.toFixed(2) + ' mm)<br>'
            + '<span class="conduit-badge ' + (badgeOk ? 'badge-ok' : 'badge-err') + '">' + badgeTxt + '</span>'
          + '</div>'
        + '</div>'

        + '<div class="conduit-fill-label">'
          + '<span>' + n + ' cables = ' + p.toFixed(1) + '% ocupado</span>'
          + '<span>máximo: ' + max + ' cables = ' + pmax.toFixed(1) + '%</span>'
        + '</div>'
        + '<div class="conduit-fill-track"><div class="conduit-fill-bar" style="width:' + Math.min(p, 100).toFixed(1) + '%;background:' + barCol + '"></div></div>'
        + '<div class="conduit-fill-limit">Límite recomendado: 40% para cableado estructurado</div>'

        + specsHtml

        + '<div class="conduit-section-title">Capacidad por tamaño de conduit — ' + refCable + '</div>'
        + '<div class="conduit-all-grid">' + gridHtml + '</div>'

        + '<div class="conduit-section-title">Comparativa entre categorías — conduit ' + esc(SLBL[size]) + ' ' + tipo.toUpperCase() + '</div>'
        + '<table class="conduit-table"><thead><tr><th>Categoría</th><th>Referencia</th><th>Diámetro</th><th>AWG</th><th>Máx.</th></tr></thead>'
        + '<tbody>' + catRows + '</tbody></table>'

        + '<div class="conduit-products"><div class="conduit-prod-title">Productos en Sily.mx</div>'
        + '<div class="conduit-prod-links">' + prodLinks + '</div></div>'

        + '<div class="conduit-alert">⚠ <strong>Condulets no permitidos:</strong> Los accesorios tipo C, LB, LL, LR, T y X no están permitidos en cableado estructurado (TIA-568). Usa curvas de radio largo o cajas de paso abiertas.</div>';

      resultBox.classList.add('visible');
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Solo ejecutar en la página de la calculadora de conduit
  function maybeInit() {
    if (document.getElementById('conduit-form')) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeInit);
  } else {
    maybeInit();
  }

})();